import { createSelector } from '@ngrx/store';
import { getDragonflyLocaleState } from '../reducers/index';

export const getDragonflyLocale = createSelector(getDragonflyLocaleState, (state) => state.search);

export const getPanelExpanded = createSelector(getDragonflyLocale, ({ panelExpanded }) => panelExpanded);

export const getLiteralCode = createSelector(getDragonflyLocale, ({ literalCode }) => literalCode);

export const getLiteralText = createSelector(getDragonflyLocale, ({ literalText }) => literalText);

export const getAvailableLanguages = createSelector(getDragonflyLocale, ({ availableLanguages }) => availableLanguages);

export const getSelectedLanguage = createSelector(getDragonflyLocale, ({ selectedLanguage }) => selectedLanguage);

export const getLiterals = createSelector(getDragonflyLocale, ({ literals }) => literals);
